// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { useField } from "formik";

import { FieldProps } from "types/form";
import { getFieldTestId } from "utils/formik";

import { Input } from "../elements";
import { createMixedValidator } from "./fieldUtils";

export function DateField(props: FieldProps) {
  const { name, required = true, type, dataTestId } = props;
  const typeFiltered = type === "datetime-local" ? "datetime-local" : "date";

  const [field, meta] = useField({
    ...props,
    required,
    type: typeFiltered,
    validate: createMixedValidator(name, required),
  });

  return (
    <Input
      {...meta}
      {...props}
      props={field}
      required={required}
      type={typeFiltered}
      dataTestId={dataTestId || getFieldTestId(name)}
    />
  );
}
